import React from "react";
import { Box, Heading, Hide } from "@catchoftheday/cg-components";
import { DesktopWrapper } from "./DesktopWrapper";
import { MobileWrapper } from "./MobileWrapper";
export const Benefits = () => {
    return (<Box mb={{ xs: 10, md: 20 }}>
      <Heading.h4 mb={{
            xs: 2,
            md: 4,
        }} color="onePass.textPrimary" fontWeight="bold">
        You&apos;ll get access to:
      </Heading.h4>
      <Hide md lg xl>
        <MobileWrapper />
      </Hide>
      <Hide xs sm>
        <DesktopWrapper />
      </Hide>
    </Box>);
};
